module.exports = __webpack_public_path__ + "static/media/SAS Alert Tone 10.87f6ae0e.mp3";